import { call, put } from 'redux-saga/effects';
import { auth } from 'mz-sdk';
import { resetPostHogUser } from 'app/integrations';
import { showNotification } from 'app/actions/notifications';
import { NOTIFICATION_ERROR } from 'app/constants';
import { removeCookie } from 'app/utils/cookie';
import { appendPropagatedParameters } from 'app/history';

export default function* doLogout() {
  try {
    yield call(auth.logout);

    // Delete user data for third-party libs.
    window.mozioUser = null;
    resetPostHogUser();

    // Drop the shared TA locale preference so a later cold load resolves fresh.
    removeCookie('ta-locale');

    // Full-page reload so nginx routes / to the correct app (transfer-next on www.mozio.com).
    // Keep the params that must persist across pages (PROPAGATE_PARAMS, e.g. `ref`)
    // from the current URL instead of dropping them on the bare `/`, but drop `ta`
    // since the Travel Agent context ends with the session.
    window.location.href = appendPropagatedParameters('/', ['ta']); // eslint-disable-line require-atomic-updates
  } catch (error) {
    yield put(showNotification({
      type: NOTIFICATION_ERROR,
      message: error.message
    }))
  }
}
